const CalendarManager = (function () {
  const ringCalendarEvent = () => {
    throw new Error('ringCalendarEvent is not implemented on web')
  }
  return {
    ringCalendarEvent
  }
})()

export default CalendarManager
